module.exports = {"341171001":"大王街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341171.json
// module id = 1116
// module chunks = 0